import Task16 from '@carbon/icons-react/es/task/16';
import { memoize } from 'lodash';
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import type { Translate } from 'hooks/use-translation';
import type { ProjectField, TaskField } from 'stores/fields';
import { FieldType, FilterableField } from '../fields';

/**
 * TODO: Memoize with translation language
 * but expectation is that app reloads on changing language
 * */

const headerTemplate = memoize(
  (
    type: FieldType,
    editable: boolean,
    translate: Translate,
    isProjectHeader: boolean,
    description?: string,
  ) =>
    `<div class="ag-cell-label-container" role="presentation">
      <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
      <div ref="eLabel" class="ag-header-cell-label" role="presentation">
        ${
          isProjectHeader
            ? renderToStaticMarkup(
                <div
                  className="ag-header-custom-icon"
                  title={translate('task_list.messages.project_field')}
                >
                  <Task16 />
                </div>,
              )
            : ''
        }
        <span ref="eText" title="${
          description ?? ''
        }" class="ag-header-cell-text" role="columnheader"></span>
        <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
        <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>
        <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>
        <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>
        <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>
      </div>
    </div>`,
  (type: FieldType, editable: boolean, label?: string, description?: string) =>
    `${type}:${editable}:${label}:${description}`,
);

export const getHeaderTemplate = ({
  field,
  editable,
  translate,
  isProjectHeader = false,
}: {
  field: TaskField | ProjectField | FilterableField;
  editable: boolean;
  translate: Translate;
  isProjectHeader?: boolean;
}): string | undefined => {
  return headerTemplate(
    field.type,
    editable,
    translate,
    isProjectHeader,
    field.description,
  );
};
